import { useMutation } from "react-query";
import { PartnerApi } from "../../api/partner.api";
import { useSoldSNStore } from "../../store/soldsn.store";

export const useFoundSNList = () => {
  const setFoundSNList = useSoldSNStore((state) => state.setFoundSNList);

  return useMutation(PartnerApi.soldSNSearch, {
    onSuccess: (data) => {
      setFoundSNList(data);
    },
    onError: (error) => {
      console.error("Login failed:", error);
    },
  });
};
